// src/components/OptimizedImage.tsx
import React, { useState } from 'react'; // ← Eliminamos useEffect

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({ 
  src, 
  alt, 
  className = '', 
  width, 
  height, 
  loading = 'lazy',
  priority = false
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  const generateAltText = () => {
    const baseDescriptions: Record<string, string> = {
      'LOGOAZUL-Ajpg.jpg': 'Algorithmia - Desarrollo de Software a Medida en Córdoba, Argentina - Expertos en Sistemas de Gestión Empresarial y PWA',
      'logo inicial.jpeg': 'Algorithmia - Soluciones Tecnológicas Empresariales, Software Personalizado y Consultoría Tecnológica en Argentina',
    };
    
    const fileName = src.split('/').pop() || '';
    if (baseDescriptions[fileName]) {
      return baseDescriptions[fileName];
    }
    
    return alt || 'Algorithmia - Desarrollo de Software y Soluciones Digitales';
  };

  const loadingMode = priority ? 'eager' : loading;

  return (
    <div className={`relative overflow-hidden ${className}`} style={{ width, height }}>
      {!isLoaded && !error && (
        <div className="absolute inset-0 bg-gradient-to-r from-gray-700 to-gray-800 animate-pulse" />
      )}
      
      <img
        src={src}
        alt={generateAltText()}
        loading={loadingMode}
        className={`transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'} ${className}`}
        width={width}
        height={height}
        itemProp="image"
        title={generateAltText()}
        onLoad={() => setIsLoaded(true)}
        onError={() => {
          setError(true);
          console.error(`Error loading image: ${src}`);
        }}
      />
      
      {error && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-800/50">
          <span className="text-white/50 text-sm">Imagen no disponible</span>
        </div>
      )}
    </div>
  );
};

export default OptimizedImage;